






import { Prop, Component, Vue } from "vue-property-decorator";
import VGrid from "@/components/VGrid.vue";

@Component({
  components: {
    VGrid
  }
})
export default class ScheduleRow extends Vue {
  @Prop({ required: true }) cols!: number;
}
